import type { ThemeConfig } from 'antd'

export const global: ThemeConfig = {
    token: {
        colorBgLayout: '#fff',
    }
};
